import {ModuleProto} from "../module-proto";
import {ModuleType} from "../types";
import {SettingsMenuTopCategory} from "../settings-module";
import {SettingsParentSection} from "../../../app/settings/const";

// const debug = "ViewMyCalendarModule"
const debug = false

export class ViewMyCalendarModule extends ModuleProto {

    constructor(moduleConfig: JSONObject) {
        super(ModuleType.VIEW_MY_CALENDAR, moduleConfig);

        debug && console.log(debug, "constructor() moduleConfig=", moduleConfig)

        this.name                    = "My Calendar"
        this.description             = ""
        this.svgIcon                 = "isvg-view-my-calendar"
        this.settingsMenuTopCategory = SettingsMenuTopCategory.ORGANIZATION
        this.typeLabel               = "Views"
        this.settingsUrl             = "settings/view-my-calendar"
        this.parentSection              = SettingsParentSection.VIEWS
    }

    toJson() {
        debug && console.log(debug, "toJson() type=", this.type, "_isEnabled=", this._isEnabled)
        const result = super.toJson();
        debug && console.log(debug, "    newConfig=", result)

        return result
    }

}